import React from 'react'
import styles from './UIGameBottomLandscape.module.scss'
import {UIGameTradeCreator} from '../UIGameTradeCreator/UIGameTradeCreator'
import {UIGameActionButtonContainer} from '../UIGameActionButtonsContainer'
import {useGameStore} from '../../store/GameStoreContext'
import {UIGameActionBoxContainer} from '../UIGameActionBox/UIGameActionBoxContainer'
import {useIsReplay} from '../../store/selectors/useIsReplay'
import clsx from 'clsx'
import {UIGameDiceGroupContainer} from '../../common/UIGameDiceGroup/UIGameDiceGroupContainer'

export const UIGameBottomLandscape = () => {
    const isReplay = useIsReplay()
    const myColor = useGameStore((state) => state.myColor)
    const isMyColorSpectator = useGameStore((state) => state.isMyColorSpectator)

    return <div className={clsx(styles.bottomContainerLandscape, {
        [styles.replay]: isReplay || isMyColorSpectator,
    })}>
        <div className={styles.actionBoxContainer}>
            <UIGameActionBoxContainer />
        </div>
        {isMyColorSpectator ?
            <div className={styles.gameInventorySpectatorContainer}/>
            : <UIGameTradeCreator className={styles.gameInventoryContainer}/>}
        <div className={styles.rightContainer}>
            <UIGameDiceGroupContainer playerColor={myColor} size='large' className={styles.diceGroup}/>
            <UIGameActionButtonContainer className={styles.actionButtonContainer}/>
        </div>
    </div>
}
